import { useQuery } from 'react-query';
import { api } from 'api/api';

export const useGetNews = (teamId, leagueId, isLeagueSpecific = false) =>
  useQuery({
    queryKey: ['getNews', teamId, leagueId, isLeagueSpecific],
    queryFn: () => {
      if (isLeagueSpecific && leagueId) {
        return api.news.getAllNewsByLeague(leagueId);
      }
      return api.news.getAllNewsByTeam(teamId);
    },
    enabled: isLeagueSpecific ? !!leagueId : !!teamId,
  });
